<template>
  <b-modal class="modal-lg" id="postModal" ref="post-modal" :title="postModal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="fetchAdditionalInfo(postModal.modalData.entries)" @hide="resetModal('main')">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'envelope']" size="1x" class="mr-2"/> {{ postModal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="vld-parent text-center">
        <div autofocus>
          <!--<div @transitioncancel="loaderStopped">-->
            <loading
            :active.sync="postModalIsBusy"
            :can-cancel="false"
            :color="'#047bf8'"
            :loader="'dots'"
            :is-full-page="false"></loading>
          <!--</div>-->
          <div v-if="!postModalIsBusy" >
            <template v-if="postModal.modalData.entries == 'single'">
              <template v-if="postModal.docuData.docsChecked.length && postModal.docuData.docsChecked[0]">
                <h5 class="py-2">{{ t('docPostModalHeading','docPostModalHeading') }}</h5>
                <div class="mb-2 form-row">
                    <label v-if="postModal.updateData.post_address && (postModal.updateData.post_address.length > 2)" for="post-address" class="d-block">{{t('labelPostAddressIfDiff','labelPostAddressIfDiff') }}</label>
                    <label v-else for="post-address" class="d-block">{{t('labelGivePostAddress','labelGivePostAddress') }}</label>
                    <b-form-textarea id="post-address" v-model="postModal.updateData.post_address" class="form-control" rows="5" max-rows="5">
                    </b-form-textarea>
                </div>
                <div class="mt-2 form-row" style="display: flex; align-items: center">
                  <span class="mr-2">{{ t('docSendLinkedDocsQuestion', 'docSendLinkedDocsQuestion') }}</span><input type="text" class="form-control" v-model="docLevels" style="width: 40px;" />
                </div>
              </template>
              <template v-else>
                <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
                <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
              </template>
            </template>
            <template v-if="postModal.modalData.entries == 'multi'">
              <template v-if="postModal.docuData.docsChecked.length">
                <h5 class="py-2">{{ t('docPostModalHeading','docPostModalHeading') }}</h5>
                <div class="form-row">
                    <label v-if="postModal.updateData.post_address && (postModal.updateData.post_address.length > 2)" for="post-address" class="d-block">{{t('labelPostAddressIfDiff','labelPostAddressIfDiff') }}</label>
                    <label v-else for="post-address" class="d-block">{{t('labelGivePostAddress','labelGivePostAddress') }}</label>
                    <b-form-textarea id="post-address" v-model="postModal.updateData.post_address" class="form-control" rows="5" max-rows="5">
                    </b-form-textarea>
                </div>
              </template>
              <template v-else>
                <h5 class="text-danger text-center"><fontAwesomeIcon :icon="['fas', 'exclamation-triangle']" size="1x" class="mr-2"/> {{t('noDocsSelected','noDocsSelected')}}</h5>
                <p class="text-danger text-center">{{t('pleaseSelectDocsFirst','pleaseSelectDocsFirst')}}</p>
              </template>
            </template>
          </div>
        </div>
      </div>
      <!--<ResponseInfo class="px-0 mx-0 mt-3" v-if="getResponseInfo.responseName == 'documentsView'"></ResponseInfo>-->
      <template v-if="getResponseInfo.restricted">
        <p class="text-center">{{t('docEmailModalNoPermissionToSendTheFollowing','docEmailModalNoPermissionToSendTheFollowing')}}</p>
        <figure class="text-center">
          <figcaption>{{t('labelDocuments', 'labelDocuments')}}</figcaption>
          <ul>
            <li v-for="docId in getResponseInfo.restricted" v-bind:key="docId" >id: {{ docId }}</li>
          </ul>
        </figure>
      </template>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
        </button>
        <template v-if="((postModal.modalData.entries == 'multi') && postModal.docuData.docsChecked.length) || (postModal.modalData.entries == 'single')">
          <div v-if="buttonIsBusy">
            <div class="sk-folding-cube">
              <div class="sk-cube1 sk-cube"></div>
              <div class="sk-cube2 sk-cube"></div>
              <div class="sk-cube4 sk-cube"></div>
              <div class="sk-cube3 sk-cube"></div>
            </div>
          </div>
          <button v-if="!buttonIsBusy && isButtonActive" aria-label="SendByPost" data-dismiss="modal" class="btn btn-primary" type="button" @click="sendByPost()">
            <fontAwesomeIcon :icon="['fa', 'paper-plane']" class="text-light mr-2"/> {{ t('postButtonText', 'postButtonText')}}
          </button>
        </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'ModalPostDoc',
  //this component inherits from the Search.vue component
  inject: [
    'resetModal'
  ],
  data () {
    return {
      postModal: {},
      buttonIsBusy: false,
      loaderBusy: true,
      postModalIsBusy: true,
      isAlternateAddress: false,
      docLevels: 0,
      isActive: true
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    postalAddress: {
      get(){
        return this.$store.getters['documentToolsStore/getPostalAddress']
      }
    },
    isButtonActive() {
      if(this.postModal && this.postModal.modalData) {
        if(this.postModal.modalData.entries == 'single') {
          if(this.postModal.docuData.docsChecked.length && this.postModal.docuData.docsChecked[0]) {
            return true
          } else {
            return false
          }
        } else if(this.postModal.modalData.entries == 'multi') {
          if(this.postModal.docuData.docsChecked.length && this.postModal.docuData.docsChecked.length > 1) {
            return true
          } else {
            return false
          }
        }
      }

      return false
    }
  },
  methods:{
    fetchAdditionalInfo(entries) {
      //clear previous response
      this.$store.dispatch('alertClearResponse')

      this.postModalIsBusy = true
      this.loaderBusy = true
      this.docLevels = 0

      if(entries == 'single') {
        this.$store.dispatch('documentToolsStore/getPostalAddress',{
          documents: this.postModal.docuData.docsChecked[0]
        })
        .then(() => {
          this.postModal.updateData.post_address = this.postalAddress
          this.postModalIsBusy = false
        })
      }

      if(entries == 'multi') {
        this.$store.dispatch('documentToolsStore/getPostalAddress',{
          documents: this.postModal.docuData.docsChecked
        })
        .then(() => {
          this.postModal.updateData.post_address = this.postalAddress
          this.postModalIsBusy = false
        })
      }

    },
    sendByPost() {
      if(this.postModal.updateData.post_address != this.postalAddress) {
        this.isAlternateAddress = true
      }

      this.$store.dispatch('documentToolsStore/handleDocumentTool', {
        action: 'postDocument',
        documents: this.postModal.docuData.docsChecked,
        postAddress: this.postModal.updateData.post_address,
        isAlternateAddress: this.isAlternateAddress,
        docLevels: this.docLevels
      })
      .then(() => {
        this.buttonIsBusy = false
        this.isAlternateAddress = false
        let responseStatus = this.getResponseInfo.status
        if(responseStatus != 'error'){
          this.$refs['post-modal'].hide()
        }
      })
    },
    /*
    loaderStopped() {
      this.loaderBusy = false
    }*/
  },
  created() {
    this.postModal = this.$attrs.modal
  },
  components:{
    ResponseInfo,
    Loading
  }
}
</script>

<style scoped>
.button-h {
  max-height: 30px;
}
</style>
